<template>
	<iframe class="arp-iframe" :src="urlAcessoDocumento"></iframe>
</template>

<script>
export default {
	name: 'termo-desentranhamento-redigir',
	props: {
		urlAcessoDocumento: {
			type: String,
			default: '',
		},
	},
}
</script>
